import React from 'react';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/client';
import { FieldSelectDB, FsProps } from 'motion-components';
import { useTranslation } from 'react-i18next';

const gqlGetValues = gql`
  query getValues($where: String, $offset: Int, $limit: Int, $order: String) {
    getCntContributionsPeriodgroups(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id
        description: name
      }
      recordCount
    }
  }
`;

export function useGetContributionPeriodAsOptionsQuery() {
  return useLazyQuery(gqlGetValues);
  //return [null, { loading: null, data: null }];
}

export const FieldSelectContributionPeriodGroups = ({
  label = 'Περιοδικότητα Δηλώσεων',
  name = 'contributionPeriodGroupId',
  defaultValues = {},
  ...rest
}: FsProps) => {
  const { t } = useTranslation();
  const where = JSON.stringify({ isActive: true });
  return (
    <FieldSelectDB
      {...rest}
      label={t(label)}
      name={name}
      // @ts-ignore
      //sbLabel={defaultValues?.batteriescollectionsState?.name ?? undefined}
      where={where}
      hook={useGetContributionPeriodAsOptionsQuery}
    />
  );
};

